import { render } from "./WatchFunds.vue?vue&type=template&id=054569aa&scoped=true"
import script from "./WatchFunds.vue?vue&type=script&lang=js"
export * from "./WatchFunds.vue?vue&type=script&lang=js"

import "./WatchFunds.vue?vue&type=style&index=0&id=054569aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054569aa"]])

export default __exports__